import React, { useCallback } from "react";
import { useFocusEffect } from "@react-navigation/native";
import AdminRecentActivity from "../../components/adminDashboard/AdminRecentActivity/AdminRecentActivity";
import { useGetAuditEventsQuery } from "@axio/graphql/generated/graphql";

const AdminRecentActivityContainer = () => {
  const { data: auditEventsData, refetch } = useGetAuditEventsQuery();
  const events =
    auditEventsData?.getAuditEvents?.success === false ? [] : (auditEventsData?.getAuditEvents?.data ?? []);

  useFocusEffect(
    useCallback(() => {
      void refetch();
      return undefined;
    }, [refetch])
  );

  return <AdminRecentActivity events={events} />;
};

export default AdminRecentActivityContainer;
